import { render, staticRenderFns } from "./bale-abroadorder.vue?vue&type=template&id=4e5cf3e3&"
import script from "./bale-abroadorder.vue?vue&type=script&lang=ts&"
export * from "./bale-abroadorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports